import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import ReactSelectMaterialUi from 'react-select-material-ui';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ImagePreview from '../../components/molecules/ImagePreview';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  marginBottom12: {
    marginBottom: '12px'
  },
  selectContainer: {
    marginLeft: 40,
    marginRight: 40
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    prefectures: state.commons.prefectures,
    statuses: state.shops.statuses,
    shopCategories: state.commons.shopCategories
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    editAction,
    editConfirm,
    prefectures,
    shopCategories,
    enableShopBank,
    openEditProgress,
    progressOkAction,
    loading,
    resultMessage,
    roles,
    isLanguage,
    setIsLanguage,
    otherData
  }) => {
    let {
      shopName,
      shopNameKana,
      address1,
      // address2,
      building,
      shopGroupName,
      shopContactName,
      department,
      introduction,
      businessHours,
      holiday,
      nearestStation,
      access,
      numberSit,
      smoking,
      parking
    } = editConfirm;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = editConfirm.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData && languageData.translateType) {
        ({
          shopName,
          shopNameKana,
          shopGroupName,
          shopContactName,
          department,
          introduction,
          businessHours,
          holiday,
          nearestStation,
          access,
          numberSit,
          smoking,
          parking
        } = languageData.params);
      } else {
        shopName = 'Google Translate で自動的に翻訳されるもの';
        shopNameKana = 'Google Translate で自動的に翻訳されるもの';
        shopGroupName = 'Google Translate で自動的に翻訳されるもの';
        shopContactName = 'Google Translate で自動的に翻訳されるもの';
        department = 'Google Translate で自動的に翻訳されるもの';
        introduction = 'Google Translate で自動的に翻訳されるもの';
        businessHours = 'Google Translate で自動的に翻訳されるもの';
        holiday = 'Google Translate で自動的に翻訳されるもの';
        nearestStation = 'Google Translate で自動的に翻訳されるもの';
        access = 'Google Translate で自動的に翻訳されるもの';
        numberSit = 'Google Translate で自動的に翻訳されるもの';
        smoking = 'Google Translate で自動的に翻訳されるもの';
        parking = 'Google Translate で自動的に翻訳されるもの';
      }

      address1 = 'Google Translate で自動的に翻訳されるもの';
      // address2 = 'Google Translate で自動的に翻訳されるもの';
      building = 'Google Translate で自動的に翻訳されるもの';
    }

    return (
      <div className={classes.root}>
        <Typography variant="h6">店舗編集確認</Typography>
        <div className={classes.selectContainer}>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableRow>
              <TableCell className={classes.tableCellItem}>店舗名</TableCell>
              <TableCell className={classes.tableCellData}>
                {shopName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗名かな
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {shopNameKana}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>郵便番号</TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.zipCode}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>都道府県</TableCell>
              <TableCell className={classes.tableCellData}>
                {prefectures.map(item => {
                  if (
                    editConfirm.prefectureCode &&
                    editConfirm.prefectureCode.toString() === item.id.toString()
                  ) {
                    return item.name;
                  }
                  return '';
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>市区町村</TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.city}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                町域・番地
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {address1}
              </TableCell>
            </TableRow>
            {/* <TableRow>
              <TableCell className={classes.tableCellItem}>番地</TableCell>
              <TableCell className={classes.tableCellData}>
                {address2}
              </TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell className={classes.tableCellItem}>建物名</TableCell>
              <TableCell className={classes.tableCellData}>
                {building}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗カテゴリー
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {shopCategories.map(item => {
                  if (
                    editConfirm.shopCategoryId &&
                    editConfirm.shopCategoryId.toString() === item.id.toString()
                  ) {
                    return item.name;
                  }
                  return '';
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                運営会社名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {shopGroupName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                ご担当者名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {shopContactName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>所属部署</TableCell>
              <TableCell className={classes.tableCellData}>
                {department}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                電話番号（担当者）
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.contactPhone}
              </TableCell>
            </TableRow>
            {!editConfirm.paymentGroupId && (
              <>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    インボイス制度 適格事業者登録
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {editConfirm.haveRegistrationId ? '登録済み' : '未登録'}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    適格事業者登録番号
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {// eslint-disable-next-line no-nested-ternary
                    editConfirm.paymentGroupId
                      ? editConfirm.groupRegistrationId
                      : editConfirm.haveRegistrationId
                      ? editConfirm.registrationId
                      : undefined}
                  </TableCell>
                </TableRow>
              </>
            )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗電話番号
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.phone}
                {!roles.isShop && (
                  <frameElement>
                    {'('}
                    {editConfirm.showPhone ? `表示` : `非表示`}
                    {')'}
                  </frameElement>
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                こども食堂設定
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {!roles.isShop && (
                  <frameElement>
                    {editConfirm.childShopFlag ? `設定済` : ``}
                  </frameElement>
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                メールアドレス
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.email}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>店舗概要</TableCell>
              <TableCell className={classes.tableCellData}>
                {introduction}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>営業時間</TableCell>
              <TableCell className={classes.tableCellData}>
                {businessHours}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>定休日</TableCell>
              <TableCell className={classes.tableCellData}>{holiday}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>価格帯</TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.priceRange}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>最寄り駅</TableCell>
              <TableCell className={classes.tableCellData}>
                {nearestStation}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>アクセス</TableCell>
              <TableCell className={classes.tableCellData}>{access}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                WebページURL
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.webPage}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>タグ</TableCell>
              <TableCell className={classes.tableCellData}>
                {otherData.tagStr}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>画像</TableCell>
              <TableCell className={classes.tableCellData}>
                <ImagePreview previewImage={otherData.previewImage1} />
                <ImagePreview previewImage={otherData.previewImage2} />
                <ImagePreview previewImage={otherData.previewImage3} />
                <ImagePreview previewImage={otherData.previewImage4} />
                <ImagePreview previewImage={otherData.previewImage5} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>SNS</TableCell>
              <TableCell className={classes.tableCellData}>
                <div className={classes.margin}>
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid item>
                      <CardMedia
                        component="img"
                        alt="Facebook"
                        height="24"
                        image="/images/icon_facebook.png"
                        title="Facebook"
                        className={classes.marginBottom12}
                      />
                    </Grid>
                    <Grid item xs={12} sm container>
                      <TableCell className={classes.tableCellData}>
                        {editConfirm.snsFacebook}
                      </TableCell>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid item>
                      <CardMedia
                        component="img"
                        alt="Twitter"
                        height="24"
                        image="/images/icon_twitter.png"
                        title="Twitter"
                        className={classes.marginBottom12}
                      />
                    </Grid>
                    <Grid item xs={12} sm container>
                      <TableCell className={classes.tableCellData}>
                        {editConfirm.snsTwitter}
                      </TableCell>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid item>
                      <CardMedia
                        component="img"
                        alt="Instagram"
                        height="24"
                        image="/images/icon_instagram.png"
                        title="Instagram"
                        className={classes.marginBottom12}
                      />
                    </Grid>
                    <Grid item xs={12} sm container>
                      <TableCell className={classes.tableCellData}>
                        {editConfirm.snsInstagram}
                      </TableCell>
                    </Grid>
                  </Grid>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>座席</TableCell>
              <TableCell className={classes.tableCellData}>
                {numberSit}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>禁煙/喫煙</TableCell>
              <TableCell className={classes.tableCellData}>{smoking}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>駐車場</TableCell>
              <TableCell className={classes.tableCellData}>{parking}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗詳細表示制限
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {otherData.stealthModeStr}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                誰でもごち制限
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {otherData.gochiRestrictionStr}
              </TableCell>
            </TableRow>
            {/* <TableRow>
              <TableCell className={classes.tableCellItem}>
                社食ごちめし現金授受の有無
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.cashAllowed ? '受け付ける' : '受け付けない'}
              </TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                社食ごちめし金額指定チケット利用の有無
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {editConfirm.shopDetail &&
                editConfirm.shopDetail.allowMenuPriceShashoku
                  ? '利用する'
                  : '利用しない'}
              </TableCell>
            </TableRow>
            {enableShopBank && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  売上受取方法
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {otherData.depositManageStr}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>銀行名</TableCell>
                <TableCell className={classes.tableCellData}>
                  {otherData.bankName}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>支店名</TableCell>
                <TableCell className={classes.tableCellData}>
                  {otherData.bankBranchName}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  口座種別
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {otherData.bankAccountTypeStr}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  口座番号
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {otherData.bankAccountNumber}
                </TableCell>
              </TableRow>
            )}
            {enableShopBank && editConfirm.depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  口座名義
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {otherData.bankAccountHolder}
                </TableCell>
              </TableRow>
            )}
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={editAction} />
        </div>
        <ProgressDialog
          openProgress={openEditProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
